// "Sign up with Google" outside the sign-up page: opens /signup, which starts Google sign-in right
// away — so the return trip from Google lands on the page that finishes signing in.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import google_logo from '../../assets/images/logo/google-big-logo.png';

export default function GoogleButton({ label = 'Sign up with Google' }) {
  const navigate = useNavigate();
  return (
    <button type="button" className="mk-btn mk-btn--light" onClick={() => navigate('/signup', { state: { google: true } })}>
      <img src={google_logo} alt="" className="mk-btn-logo" width="18" height="18" />
      {label}
    </button>
  );
}
